"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reduxModal = require("redux-modal");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _blocks = require("@bueno/blocks");

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _components = require("../../components");

var usersActions = _interopRequireWildcard(require("../../redux/modules/users/actionCreators"));

var _actionCreators2 = require("../../redux/modules/lookups/actionCreators");

var _UserTable = require("../../components/UserTable");

var _Page = require("../../components/Layout/Page");

var _CreateUserModal = _interopRequireWildcard(require("./components/CreateUserModal"));

var _EditUserModal = _interopRequireWildcard(require("./components/EditUserModal"));

var _dec, _class, _class2, _temp;

const StyledWrap = (0, _styledComponents.default)(_Page.Wrap)`
  padding-top: ${_blocks.spacing.loose};
`;
const StyledTitle = (0, _styledComponents.default)(_blocks.DisplayMedium)`
  text-align: center;
  margin-bottom: ${_blocks.spacing.loose};
`;
const StyledThirds = (0, _styledComponents.default)(_blocks.Thirds)`
  margin-bottom: ${_blocks.spacing.default};
`;

function getRolesSelectOptions(user, roles) {
  let roleOptions = roles;

  if (user.access.includes('limitRoleOnRegister')) {
    const roleOptionsRestricted = {};
    user.rolesRestriction.forEach(role => {
      roleOptionsRestricted[role] = role;
    });
    roleOptions = roleOptionsRestricted;
  }

  return Object.keys(roleOptions).map(key => ({
    value: key,
    label: key
  }));
}

function isParentUser(user) {
  return user.status === 'active' && Boolean(user.is_sub_user) === false;
}

function makeSearchable(users) {
  return users.map(user => {
    const targetValueString = Object.values(user).join(' ').replace(/,/g, ' ');
    return { ...user,
      targetValueString
    };
  });
}

const SEARCH_KEY = 'userSearch';
let UserAdmin = (_dec = (0, _reactRedux.connect)(state => ({
  users: state.users.users,
  groups: state.lookups.groups,
  roles: state.lookups.roles,
  user: state.auth.user,
  statuses: state.users.statuses,
  adding: state.users.adding,
  editing: state.users.editing,
  viewing: state.users.viewing,
  working: state.users.working,
  toggleDeactivateWorking: state.users.toggleDeactivateWorking,
  modal_data: state.users.modal_data,
  user_form_data: state.users.user_form_data,
  submit_func: state.users.submit_func,
  error: state.users.error,
  success: state.users.success,
  activeModal: state.betaModal
}), dispatch => ({ ...(0, _redux.bindActionCreators)({ ...usersActions,
    loadGroups: _actionCreators2.loadGroups
  }, dispatch),
  closeModal: modalName => {
    dispatch((0, _reduxModal.hide)(modalName));
  },
  clearForm: () => {
    dispatch(usersActions.handleClose());
  },
  handleCreateUserFormOpen: () => {
    dispatch(usersActions.startAddUser());
    dispatch((0, _reduxModal.show)(_CreateUserModal.CREATE_USER_MODAL));
  },
  handleEditUserFormOpen: user => {
    dispatch(usersActions.startViewUser(user));
    dispatch((0, _reduxModal.show)(_EditUserModal.EDIT_USER_MODAL));
  }
})), _dec(_class = (_temp = _class2 = class UserAdmin extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      searchableUsers: [],
      filteredUsers: [...this.props.users],
      query: undefined
    });
    (0, _defineProperty2.default)(this, "setInitialUsers", users => {
      this.setState({
        searchableUsers: makeSearchable(users),
        filteredUsers: this.props.users
      });
    });
    (0, _defineProperty2.default)(this, "handleModalClose", () => {
      const activeModalName = Object.keys(this.props.activeModal)[0];
      this.props.clearForm();
      this.props.closeModal(activeModalName);
    });
    (0, _defineProperty2.default)(this, "handleSearch", ({
      filtered,
      query
    }) => {
      this.setState({
        filteredUsers: filtered,
        query
      });
    });
  }

  componentDidMount() {
    this.props.loadUsers(this.props.user);
    this.props.loadGroups('userAdmin');
    this.setInitialUsers(this.props.users);
  }

  componentDidUpdate({
    users,
    success
  }) {
    if (users !== this.props.users) {
      this.setInitialUsers(this.props.users);
    }

    if (!success && this.props.success) {
      this.handleModalClose();
    }
  }

  render() {
    const {
      user,
      users,
      groups,
      statuses,
      roles,
      handleChange,
      handleSubmit,
      submit_func: submitFunc,
      toggleSubUser,
      handleToggleDeactivate,
      handleCreateUserFormOpen,
      handleEditUserFormOpen,
      addUserRequest,
      modal_data: modalData,
      user_form_data: userFormData,
      editing,
      toggleDeactivateWorking,
      error,
      success
    } = this.props; // If no access, redirect to 404

    if (user.access && !user.access.includes('userAdmin')) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/404"
    }); // This is for the parent user lookup

    const usersLookup = users ? users.filter(isParentUser).map(u => ({
      value: u.user_id,
      label: u.user_fullname
    })) : [];
    return /*#__PURE__*/_react.default.createElement(StyledWrap, null, /*#__PURE__*/_react.default.createElement(StyledTitle, null, "Manage Users"), /*#__PURE__*/_react.default.createElement(StyledThirds, null, /*#__PURE__*/_react.default.createElement(_blocks.Left, null, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
      additive: true,
      thin: true,
      onClick: handleCreateUserFormOpen
    }, "Invite User")), /*#__PURE__*/_react.default.createElement(_blocks.Center, null, /*#__PURE__*/_react.default.createElement(_blocks.Search, {
      sessionKey: SEARCH_KEY,
      initialSearch: this.state.query,
      data: this.state.searchableUsers,
      onSearch: this.handleSearch,
      defaultField: "targetValueString",
      searchFields: ['fullName', 'email'],
      indexId: "id",
      placeholder: "Search Users",
      thick: true,
      cy: "Users-Search"
    })), /*#__PURE__*/_react.default.createElement(_blocks.Right, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.default, {
      title: "Administration"
    }))), /*#__PURE__*/_react.default.createElement(_components.MsgAlert, {
      type: "success",
      message: success
    }), /*#__PURE__*/_react.default.createElement(_CreateUserModal.default, {
      title: modalData.title,
      submitText: modalData.submitText,
      handleClose: this.handleModalClose,
      userFormData: userFormData,
      usersLookup: usersLookup,
      handleChange: handleChange,
      addUserRequest: addUserRequest,
      error: error,
      user: user,
      groups: groups,
      rolesSelectOptions: getRolesSelectOptions(user, roles)
    }), /*#__PURE__*/_react.default.createElement(_EditUserModal.default, {
      title: modalData.title,
      submitText: modalData.submitText,
      handleClose: this.handleModalClose,
      userFormData: userFormData,
      usersLookup: usersLookup,
      handleChange: handleChange,
      handleSubmit: handleSubmit,
      submitFunc: submitFunc,
      error: error,
      disabled: !editing,
      user: user,
      groups: groups,
      rolesSelectOptions: getRolesSelectOptions(user, roles),
      handleToggleDeactivate: handleToggleDeactivate,
      toggleDeactivateWorking: toggleDeactivateWorking,
      toggleSubUser: toggleSubUser
    }), /*#__PURE__*/_react.default.createElement(_blocks.Frame, null, /*#__PURE__*/_react.default.createElement(_blocks.FrameContent, null, users.length > 0 && /*#__PURE__*/_react.default.createElement(_UserTable.UserTable, {
      users: this.state.filteredUsers,
      groups: groups,
      onRowSelect: handleEditUserFormOpen,
      statuses: statuses,
      user: user
    }))));
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  adding: _propTypes.default.bool,
  viewing: _propTypes.default.bool,
  editing: _propTypes.default.bool,
  working: _propTypes.default.bool,
  toggleDeactivateWorking: _propTypes.default.bool,
  user: _propTypes.default.object,
  users: _propTypes.default.array.isRequired,
  groups: _propTypes.default.array,
  statuses: _propTypes.default.object,
  roles: _propTypes.default.object,
  error: _propTypes.default.string,
  success: _propTypes.default.string,
  modal_data: _propTypes.default.object,
  user_form_data: _propTypes.default.object,
  activeModal: _propTypes.default.object,
  loadUsers: _propTypes.default.func.isRequired,
  loadGroups: _propTypes.default.func.isRequired,
  startAddUser: _propTypes.default.func.isRequired,
  startViewUser: _propTypes.default.func.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  submit_func: _propTypes.default.func,
  addUserRequest: _propTypes.default.func.isRequired,
  toggleSubUser: _propTypes.default.func,
  handleToggleDeactivate: _propTypes.default.func,
  handleCreateUserFormOpen: _propTypes.default.func,
  handleEditUserFormOpen: _propTypes.default.func,
  clearForm: _propTypes.default.func,
  closeModal: _propTypes.default.func
}), _temp)) || _class);
var _default = UserAdmin;
exports.default = _default;
module.exports = exports.default;